import { Validators } from '../../../../utils/validators';
import { FormModel } from '../../../../components/Form';

export const SystemMessageForm = (strings: any): FormModel[] => {
  return [
    {
      label: strings.systemMessage_text_content,
      value: '',
      size: 'medium',
      autoFocus: true,
      type: 'text',
      typeValue: 'text',
      placeholder: '',
      field: 'template',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
      multiline: true,
      minRows: 1,
      maxRows: 50,
    },
  ];
};
